import React, { useState, useRef, useEffect, useMemo } from "react";
import {
	Modal,
	Form,
	Row,
	Col,
	Overlay,
	Popover,
	Button,
} from "react-bootstrap";
import ReactSelect from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import Flatpickr from "react-flatpickr";
import { useDispatch, useSelector } from "react-redux";
import {
	fetchIndustryData,
	setSelectedIndustry,
} from "../../redux/actions/industryActions";
import { clearCityList, fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import {
	fetchCompanyCategories,
	selectCompanyCategory,
} from "../../redux/actions/companyCategoryActions";
import { fetchJobType, selectJobType } from "../../redux/actions/jobTypeAction";
import {
	fetchWorkLevelTypeData,
	selectWorkLevel,
} from "../../redux/actions/workLevelTypeAction";
import {
	fetchWorkLocationTypeData,
	selectLocationType,
	selectWorkLocation,
} from "../../redux/actions/workLLocationTypeAction";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { customStyles } from "../../selectStyles";
import axiosInstance from "../../API/axios";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import { useParams } from "react-router-dom";
import {
	fetchCompanyData,
	selectGetCompanies,
} from "../../redux/actions/getCompaniesAction";
import moment from "moment";
import { fetchAllCompany } from "../../redux/actions/getAllCompanyAction";
import { fetchOrgRegdCompData } from "../../redux/actions/getRegdComAction";

const AddExperience = ({
	show,
	handleClose,
	userDataId,
	userDataInfo,
	getUserCv,
}) => {
	const sessionId = localStorage.getItem("sessionId");
	const userType = localStorage.getItem("userType");
	const { CandidateId } = useParams();
	const dispatch = useDispatch();
	const [display, setDisplay] = useState(false);

	const [institution, setInstitution] = useState(null);
	const [city, setCity] = useState(null);
	const [field, setField] = useState("");
	const [degree, setDegree] = useState("");
	const [profileHeadLine, setProfileHeadLine] = useState("");
	const [isPresent, setIsPresent] = useState(false);
	const [startYear, setStartYear] = useState("");
	const [endYear, setEndYear] = useState("");
	const [description, setDescription] = useState("");
	const [activities, setActivities] = useState("");

	const [showTooltip, setShowTooltip] = useState(false);
	const targetRef = useRef(null);
	const [newEducation, setNewEducation] = useState("");

	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const [designation, setDesignation] = useState("");
	const [OrganizationName, setOrganizationName] = useState("");
	const [instituteName, setInstituteName] = useState("");

	const [formChanged, setFormChanged] = useState(false); // Track if form is modified
	const [isSubmitting, setIsSubmitting] = useState(false);

	// Handle changes and mark form as modified
	const handleFieldChange = (setter, value, fieldName) => {
		setter(value);

		// Ensure values are strings (avoid .trim() errors)
		const updatedCompanyListId = fieldName === "companyListId" ? String(value || "") : String(companyListId || "");
		const updatedDesignation = fieldName === "designation" ? String(value || "") : String(designation || "");
		const updatedWorkLevelId = fieldName === "workLevelId" ? String(value || "") : String(workLevelId || "");
		const updatedWorkLocationId = fieldName === "workLocationId" ? String(value || "") : String(workLocationId || "");
		const updatedCitySearch = fieldName === "citySearch" ? String(value || "") : String(citySearch || "");
		const updatedStartDate = fieldName === "startDate" ? String(value || "") : String(startDate || "");
		const updatedEndDate = fieldName === "endDate" ? String(value || "") : String(endDate || "");
		const updatedIsPresent = fieldName === "isPresent" ? value : isPresent;

		// Check if all required fields are filled
		const allFieldsFilled =
			updatedCompanyListId.trim() !== "" &&
			updatedDesignation.trim() !== "" &&
			updatedWorkLevelId.trim() !== "" &&	
			updatedWorkLocationId.trim() !== "" &&
			updatedCitySearch.trim() !== "" &&
			updatedStartDate.trim() !== "" &&
			(updatedIsPresent || updatedEndDate.trim() !== ""); // If 'Is Present' is checked, endDate is optional

		setFormChanged(allFieldsFilled);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setDisplay(true);
		setIsSubmitting(true); // Disable the button during submission

		// Applying conditions for institution fields
		let compID = 0;
		let orgType = 0;
		let gnrlOrgCompID = 0;

		if (companyListId) {
			compID = regdType === 3 ? null : companyListId;
			orgType = regdType === 3 ? 3 : 2;
			gnrlOrgCompID = regdType === 3 ? companyListId : null;

		} else if (getOrgInsTId) {
			compID = null;
			orgType = 3;
			gnrlOrgCompID = getOrgInsTId;
		}


		const body = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: userType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,

			// orgType: companyListId === null ? newOrgType : orgType,
			// compID: companyListId,
			// gnrlOrgCompID: getOrgInsTId,

			compID,
			orgType,
			gnrlOrgCompID,

			positionHeadline: profileHeadLine,
			designation: designation,
			description: description,
			cityId: citySearch,
			jobTypeId: jobTypeId,
			workLocationTypeId: workLocationId,
			workLevelTypeId: workLevelId,
			startDate: moment(startDate).format("YYYY-MM-DD"),
			isPresent: isPresent,
			// endDate: endDate === "" ? null : moment(endDate).format("YYYY-MM-DD"),
			endDate: isPresent ? null : (endDate ? moment(endDate).format("YYYY-MM-DD") : null),

		};
		console.log("body", body);
		if (
			(companyListId === "" && getOrgInsTId === "") ||
			(orgType === "" && newOrgType === "") ||
			designation === "" ||
			jobTypeId === "" ||
			workLevelId === "" ||
			workLocationId === "" ||
			citySearch === "" ||
			startDate === "" ||
			(startDate && !isPresent && !endDate)

		) {
			toast.error("Please fill all the required fields");
			setIsSubmitting(false); // Re-enable the button if validation fails
		} else {
			const config = {
				headers: {
					Authorization: `Bearer ${sessionId}`,
					"Content-Type": "application/json",
				},
			};

			try {
				const res = await axios.post("/Resume/AddExperience", body, config);
				toast.success(res.data.message);
				resetForm();
			} catch (error) {
				if (error.response && error.response.status === 404) {
					toast.error(error.response.data.message);
				} else {
					toast.error(error.response?.data?.message || "An error occurred");
				}
			} finally {
				setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
			}
		}
	};

	const resetForm = () => {
		handleClose("");
		getUserCv();
		setCompanyListId("");
		setDesignation("");
		setProfileHeadLine("");
		setJobTypeId("");
		setWorkLevelId("");
		setworkLocationId("");
		setCitySearch("");
		setStartDate(null);
		setEndDate(null);
		setDescription("");
		setDisplay(false);
		setFormChanged(false); // Disable the button after updatef
		setIsPresent(false);
	}

	const handleCloseExperience = () => {
		resetForm(); // Call resetForm when closing the modal
		handleClose();
	};

	const [newOrgType, setnewOrgType] = useState(null);
	const [getOrgInsTId, setGenOrgInstId] = useState(null);

	const handleSaveInstitution = async () => {
		// setDisplay(true);

		const formData = new FormData();
		formData.append("orgName", OrganizationName);
		formData.append("OrgType", "UnRegdCompany");
		formData.append("CityID", orgCity);
		formData.append("OrgLogo", fileName);
		formData.append("sessionId", sessionId);
		console.log("formData", formData);

		try {
			const res = await axios.post("/Feature/AddGnrlOrgData", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			console.log("res====>", res);
			setGenOrgInstId(res.data.responseData.id);
			setnewOrgType(res.data.responseData.value);
			setOrganizationName("")
			setShowTooltip(false);
			setInsName("")
			toast.success(`${res.data.message} The newly created Company is now available at the top of the dropdown. Please select it.`);
			dispatch(fetchOrgRegdCompData());

		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.title);
			}
		}
	};

	// ...............................City DDL.......................................

	const [orgCity, setOrgCity] = useState(null);
	const [citySearch, setCitySearch] = useState("");
	const [searchTerm, setSearchTerm] = useState("")
	const [cityNameOption, setCityNameOption] = useState([])

	const getCityList = async (pageNumber = 1, pageSize = 10) => {
		try {
			const response = await axios.post(`/MasterData/GetCitiesDDL?Search=${searchTerm}&CountryName=India`, {
				pageNumber,
				pageSize
			})
			console.log("Get City Name List==>", response)
			const cityList = response.data.responseData.citiesDDL.map((val) => ({
				value: val.id,
				label: val.name,
			}));
			setCityNameOption(cityList)
		}
		catch (error) {
			//toast.error(error.message || 'Something went wrong while fetching city data',)
		}
	}

	useEffect(() => {
		getCityList();
	}, [searchTerm]);


	const handleCitySelect = (selectedOption) => {
		setCitySearch(selectedOption ? selectedOption.value : "")
		console.log("Selected City:", selectedOption);
		setSearchTerm(""); // Search term clear karein
		setCityNameOption([]); // Dropdown options clear karein
	};

	const handleCitySelectOrg = (selectedOption) => {
		setOrgCity(selectedOption ? selectedOption.value : "")
		console.log("Selected City:", selectedOption);
		setSearchTerm(""); // Search term clear karein
		setCityNameOption([]); // Dropdown options clear karein
	};
	// const { cityList, selectedcityId } =
	//   useSelector((state) => state.cities);
	// useEffect(() => {
	//   dispatch(fetchCityData());
	//   return () => {
	//     dispatch(clearCityList())
	//   }
	// }, [dispatch]);

	// const handleCityInputChange = (inputValue) => {
	//   dispatch(fetchCityData(inputValue));
	// };

	// const handleCitySelect = (selectedOption) => {
	//   if (selectedOption) {
	//     // dispatch(selectCity(selectedOption.value));
	//     setCitySearch(selectedOption.value);
	//   } else {
	//     setCitySearch(null);
	//   }
	// };
	// const handleCitySelect1 = (selectedOption) => {
	//   if (selectedOption) {
	//     setOrgCity(selectedOption.value);
	//   } else {
	//     setOrgCity(null);
	//   }
	// };

	// ...............................City DDL.......................................
	// ...............................Job Type DDL.......................................
	const [jobTypeId, setJobTypeId] = useState("");
	const { jobTypeList, selectedJobTypeId } = useSelector(
		(state) => state.jobType
	);
	useEffect(() => {
		dispatch(fetchJobType());
	}, [dispatch]);

	const handleJobType = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectJobType(selectedOption.value));
			setJobTypeId(selectedOption.value);
		} else {
			setJobTypeId(null);
		}
	};
	// ...............................Job Type DDL.......................................
	// ...............................Work Level DDL.......................................
	// Fetch work level data on component mount
	const [workLevelId, setWorkLevelId] = useState("");
	const { workLevelList, selectedworkLevelId } = useSelector(
		(state) => state.workLevelType
	);
	console.log("Work Level", workLevelList, selectedworkLevelId);

	useEffect(() => {
		dispatch(fetchWorkLevelTypeData());
	}, [dispatch]);

	const handleWorkLevel = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectWorkLevel(selectedOption.value));
			setWorkLevelId(selectedOption.value);
		} else {
			setWorkLevelId(null);
		}
	};

	// ...............................Work Level DDL.......................................
	// ...............................Work Location DDL.......................................

	const [workLocationId, setworkLocationId] = useState("");

	const { workLocation, selectedCategoryId } = useSelector(
		(state) => state.workLocationType
	);

	useEffect(() => {
		dispatch(fetchWorkLocationTypeData());
	}, [dispatch]);

	const handleWorkLoc = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectWorkLocation(selectedOption.value));
			setworkLocationId(selectedOption.value);
		} else {
			setworkLocationId(null);
		}
	};


	// ...............................Company Category DDL.......................................
	const [orgType, setOrgType] = useState("");
	const [regdType, setRegdType] = useState("");

	const [companyListId, setCompanyListId] = useState(null);
	const { getRegdCompList, selectedcompaniesId } = useSelector(
		(state) => state.getRegdComp
	);
	console.log("CompanyList===>", getRegdCompList);
	const reversedComp = useMemo(() => {
		return [...getRegdCompList].reverse(); // Create a new reversed copy
	}, [getRegdCompList]);

	useEffect(() => {
		dispatch(fetchOrgRegdCompData());
	}, [dispatch]);

	const handleSelectCompany = (selectedOption) => {

		if (selectedOption) {
			// dispatch(selectGetCompanies(selectedOption.value));
			setCompanyListId(selectedOption.value);
			setOrgType(selectedOption.tagId);
			setRegdType(selectedOption.tagId);

		} else {
			setCompanyListId(null);
			setRegdType(null)
		}
	};
	// ...............................Company Category DDL.......................................


	const [fileName, setFileName] = useState(""); // State to store selected filename
	const handleFileChange = (event) => {
		const file = event.target.files[0]; // Get the selected file
		if (file) {
			setFileName(file.name); // Set the filename in state
		}
	};
	const toggleTooltip = () => {
		console.log("Toggling Tooltip");
		setShowTooltip((prev) => !prev);
	};
	// ...............................Location DDL.......................................

	const [InsName, setInsName] = useState("");
	console.log("res====>", getOrgInsTId, companyListId);
	return (
		<Modal show={show} onHide={handleCloseExperience} centered size="lg">
			<Modal.Header>
				<Modal.Title>Add experience</Modal.Title>
				<CloseSharpIcon className="pointer" onClick={handleCloseExperience} />
			</Modal.Header>
			<Modal.Body className="settings">
				<Row>
					{/* Institution and City */}

					<Col md={6} className="mb-2">
						<Form.Group controlId="institution">
							<Form.Group controlId="Company">
								<Form.Label className="class-type">
									Company
									<span style={{ color: "red" }}> *</span>
								</Form.Label>

								{InsName !== "" ? (
									<div>
										<input
											type="text"
											value={InsName}
											placeholder="Enter org name"
											className="mb-2 form-control Normal-Input-Fill"
											disabled
										/>
									</div>
								) : (
									<div className="post-form-group mb-0">
										<ReactSelect
											options={reversedComp}
											// onChange={handleSelectCompany}
											// onChange={(selectedOption) => handleFieldChange(handleSelectCompany, selectedOption)}
											onChange={(option) => {
												handleFieldChange(setCompanyListId, option ? option.value : "", "companyListId");
												setOrgType(option ? option.tagId : null);
												setRegdType(option ? option.tagId : null);
											}}
											//  value={getRegdCompList.find((option) =>option.value === companyListId) || null}
											getOptionLabel={(option) => `${option.value}-${option.tagId}`}
											value={
												reversedComp.find((
													(option) => {
														if (InsName !== "" && InsName !== null) {
															return option.value === InsName;
														} else {
															return option.value === companyListId && option.tagId === regdType
														}
													}
												))
											}
											// onChange={(option) => {
											//   handleFieldChange(setCompanyListId, option ? option.value : ""); // Track changes
											//   setOrgType(option ? option.tag : ""); // Set organization type
											// }}
											// value={
											//   getRegdCompList.find(
											//     (option) => option.value === companyListId && option.tagId === regdType
											//   ) || null
											// }
											// getOptionLabel={(option) => `${option.value}-${option.tagId}`}
											formatOptionLabel={(option) => (
												<div style={{ fontWeight: option.tagId === 2 ? "bold" : "normal" }}>
													{option.label}
												</div>
											)}
											// styles={{
											//   control: (provided) => ({
											//     ...provided,
											//     boxShadow: "none",  // Removes the blue outline
											//     borderColor: "#ccc", // Sets a neutral border
											//     "&:hover": {
											//       borderColor: "#aaa", // Lighter border on hover
											//     },
											//   }),
											//   option: (provided, state) => ({
											//     ...provided,
											//     fontWeight: state.data.tagId === 2 ? "bold" : "normal",
											//   }),
											// }}
											placeholder="Select company"
											classNamePrefix="react-select"
											className="form-control Dark-Input-from-group"
											styles={customStyles}
											isClearable
										/>
									</div>
								)}

								{display && !companyListId ? (
									<span className="error_msg_lbl">Select Company </span>
								) : null}
							</Form.Group>
							<a
								href="#"
								ref={targetRef}
								onClick={(e) => {
									e.preventDefault();
									toggleTooltip();
								}}
								className="createModal"
							// isDisabled={!selectedIndustryId} // Disable until industry is selected
							>
								Create New
							</a>
							<Overlay
								target={targetRef.current}
								show={showTooltip}
								placement="right"
								rootClose
								container={document.querySelector(".modal")}
								onHide={() => setShowTooltip(false)} // Close when clicking outside
							>
								<Popover id="popover-basic" className="overlay-popover-modal">
									<Popover.Header as="h3" className="Dark-Body-Card-group">Create company</Popover.Header>
									<Popover.Body className="Dark-Body-Card-group">
										<Form>
											<div>
												<label className="mb-1 Text-mb-Create">Company name</label>
												<input
													type="text"
													value={OrganizationName}
													// onChange={(e) => {
													//   setOrganizationName(e.target.value);
													//   setInsName(e.target.value);
													// }}
													onChange={(e) => {
														setOrganizationName(e.target.value);
														setInsName(e.target.value);
														setCompanyListId(e.target.value); // Ensure companyListId is updated
														handleFieldChange(setCompanyListId, e.target.value, "companyListId");
													}}
													placeholder="Enter company name"
													className="mb-2 form-control Dark-Input-from-group"
												/>
											</div>
											<div>
												<label className="mb-1 Text-mb-Create">City</label>
												{/* <ReactSelect
                          options={cityList}
                          //onChange={handleCitySelect1}
                          onChange={(option) => handleFieldChange(setOrgCity, option ? option.value : "")}
                          value={
                            cityList.find(
                              (option) => option.value === orgCity
                            ) || null
                          }
                          onInputChange={handleCityInputChange}
                          placeholder="Search & Select City"
                          classNamePrefix="react-select"
                          className="form-control Dark-Input-from-group"
                          styles={customStyles}
                          isClearable
                        /> */}
												<ReactSelect
													options={cityNameOption}
													onInputChange={(value) => setSearchTerm(value)} // User input pe search ho
													onChange={handleCitySelectOrg} // Select hone ke baad clear ho jaye
													placeholder="Search & select city"
													classNamePrefix="react-select"
													className="form-control Dark-Input-from-group"
													styles={customStyles}
													isClearable
												/>
											</div>
											<div className=" mt-2 mb-2 Text-mb-Create">
												<label className="mb-1">Company logo</label>
												<input
													type="file"
													id="lastName"
													className="form-control Dark-Input-from-group"
													placeholder=""
													onChange={handleFileChange}
												//   onChange={(e) => {
												//     handleProfileImageChange(e);
												//   }}
												//   invalid={displays && profileImage === ""}
												/>
												{/* {displays && !profileImage ? (
                          <span className="error_msg_lbl text-red">
                            Upload Image{" "}
                          </span>
                        ) : null} */}
											</div>
											<div className="d-flex justify-content-end">
												<Button
													variant="primary"
													size="sm"
													onClick={handleSaveInstitution}
													className="me-2"
												>
													Save
												</Button>
												<Button
													variant="secondary"
													size="sm"
													onClick={() => {
														setShowTooltip(false);
														setOrganizationName("");
														setInsName("");
													}}
												>
													Cancel
												</Button>
											</div>
										</Form>
									</Popover.Body>
								</Popover>
							</Overlay>
						</Form.Group>
					</Col>

					<Col md={6} className="mb-2">
						<Form.Group controlId="grade">
							<Form.Label className="class-type">
								Designation
								<span style={{ color: "red" }} > *</span>
							</Form.Label>
							<Form.Control
								type="text"
								className="custom-style Dark-Input-from-group"
								value={designation}
								// onChange={(e) => setDesignation(e.target.value)}
								// onChange={(e) => handleFieldChange(setDesignation, e.target.value)} // Track changes
								onChange={(e) => handleFieldChange(setDesignation, e.target.value, "designation")}
								placeholder="Enter designation"
							/>
							{display && !designation ? (
								<span className="error_msg_lbl">Enter designation </span>
							) : null}
						</Form.Group>
					</Col>

					<Col md={6} className="mb-2">
						<Form.Group controlId="grade">
							<Form.Label className="class-type">Profile headline</Form.Label>
							<Form.Control
								type="text"
								value={profileHeadLine}
								className="custom-style Dark-Input-from-group"
								// onChange={(e) => setProfileHeadLine(e.target.value)}
								// onChange={(e) => handleFieldChange(setProfileHeadLine, e.target.value)} // Track changes
								onChange={(e) => handleFieldChange(setProfileHeadLine, e.target.value, "profileHeadLine")}
								placeholder="Profile deadline"
							/>
							{/* {display && !profileHeadLine ? (
                <span className="error_msg_lbl">Enter Profile Headline </span>
              ) : null} */}
						</Form.Group>
					</Col>

					<Col md={6} className="mb-2">
						<Form.Group controlId="city">
							<Form.Label className="class-type">
								Employment type (Job Type)
								<span style={{ color: "red" }}> *</span>
							</Form.Label>
						</Form.Group>
						<div className="post-form-group  post-form-fontExp  mb-0">
							<ReactSelect
								options={jobTypeList}
								// onChange={handleJobType}
								// onChange={(option) => handleFieldChange(setJobTypeId, option ? option.value : "")} // Track changes
								onChange={(option) => handleFieldChange(setJobTypeId, option ? option.value : "", "jobTypeId")}
								value={
									jobTypeList.find((option) => option.value === jobTypeId) ||
									null
								}
								placeholder="Select employment type"
								classNamePrefix="react-select"
								className="form-control Dark-Input-from-group"
								styles={customStyles}
								isClearable
							/>
						</div>
						{display && !jobTypeId ? (
							<span className="error_msg_lbl">Select employment type </span>
						) : null}
					</Col>

					<Col md={6} className="mb-2">
						<Form.Group controlId="city">
							<Form.Label className="class-type">
								Work level type
								<span style={{ color: "red" }} > *</span>
							</Form.Label>
						</Form.Group>
						<div className="post-form-group post-form-fontExp mb-0">
							<ReactSelect
								options={workLevelList}
								// onChange={handleWorkLevel}
								// onChange={(option) => handleFieldChange(setWorkLevelId, option ? option.value : "")} // Track changes
								onChange={(option) => handleFieldChange(setWorkLevelId, option ? option.value : "", "workLevelId")}
								value={
									workLevelList.find(
										(option) => option.value === workLevelId
									) || null
								}
								placeholder="Select work level type"
								classNamePrefix="react-select"
								className="form-control Dark-Input-from-group"
								styles={customStyles}
								isClearable
							/>
						</div>
						{display && !workLevelId ? (
							<span className="error_msg_lbl">Select work level type</span>
						) : null}
					</Col>

					{/* Start Year, End Year, Is Present */}
					<Col md={6} className="mb-2">
						<Form.Group controlId="city">
							<Form.Label className="class-type">
								Work location type
								<span style={{ color: "red" }} > *</span>
							</Form.Label>
						</Form.Group>
						<div className="post-form-group  post-form-fontExp mb-0">
							<ReactSelect
								options={workLocation}
								// onChange={handleWorkLoc}
								// onChange={(option) => handleFieldChange(setworkLocationId, option ? option.value : "")} // Track changes
								onChange={(option) => handleFieldChange(setworkLocationId, option ? option.value : "", "workLocationId")}
								value={
									workLocation.find(
										(option) => option.value === workLocationId
									) || null
								}
								placeholder="Select work location type"
								classNamePrefix="react-select"
								className="form-control Dark-Input-from-group"
								styles={customStyles}
								isClearable
							/>
						</div>
						{display && !workLocationId ? (
							<span className="error_msg_lbl">Select work location type</span>
						) : null}
					</Col>

					<Col md={6} className="mb-2">
						<Form.Group controlId="endYear" className=" Flatpickr-Calender-Class">
							<Form.Label className="class-type col-md-12">
								Start year{" "}
								<span style={{ color: "red" }}> *</span>
							</Form.Label>
							<Flatpickr
								type="number"
								value={startDate}
								className="Dark-Input-from-group"
								// onChange={(date) => setStartDate(date[0])}
								// onChange={(date) => handleFieldChange(setStartDate, (date[0]))} // Track changes
								onChange={(date) => handleFieldChange(setStartDate, date[0], "startDate")}
								placeholder="Enter start year"
								options={{
									maxDate: new Date(), // Disable future dates
									static: true, // Keeps the calendar visible on click         
								}}
							// disabled={isPresent}
							/>
							{display && !startDate ? (
								<span className="error_msg_lbl">Enter start year</span>
							) : null}
						</Form.Group>
					</Col>

					{/* {userDataInfo.isPresentExperience === true ? (
            ""
          ) : ( */}
					<Col md={6} className="d-flex align-items-center mb-2">
						<Form.Check
							type="checkbox"
							label="Is Present"
							checked={isPresent}
							onChange={(e) => handleFieldChange(setIsPresent, e.target.checked, "isPresent")}
						/>
					</Col>
					{/* )} */}

					{isPresent === false ? (
						<Col md={6} className="mb-2">
							<Form.Group controlId="endYear" className=" Flatpickr-Calender-Class">
								<Form.Label className="class-type  col-md-12">End year
									<span style={{ color: "red" }} > *</span>
								</Form.Label>
								<Flatpickr
									type="number"
									value={endDate}
									className="Dark-Input-from-group"
									// onChange={(date) => setEndDate(date[0])}
									// onChange={(date) => handleFieldChange(setEndDate, (date[0]))} // Track changes
									onChange={(date) => handleFieldChange(setEndDate, date[0], "endDate")}

									placeholder="Enter end year"
									options={{
										minDate: startDate || null, // Set minDate to startDate
										static: true, // Keeps the calendar visible on click         
									}}
								/>
							</Form.Group>
						</Col>
					) : (
						" "
					)}

					<Col md={6} className="mb-2">
						<Form.Group controlId="city">
							<Form.Label className="class-type">
								City <span className="text-red"> *</span>
							</Form.Label>
						</Form.Group>
						<div className="post-form-group mb-0">
							{/* <ReactSelect
                options={cityList}
                // onChange={handleCitySelect}
                onChange={(option) => handleFieldChange(setCitySearch, option ? option.value : "")}
                value={
                  cityList.find((option) => option.value === citySearch) || null
                }
                // onInputChange={(inputValue) => {
                //   setCityName(inputValue);
                // }}
                onInputChange={handleCityInputChange}
                placeholder="Search & Select City"
                classNamePrefix="react-select"
                className="form-control Dark-Input-from-group"
                styles={customStyles}
                isClearable
              /> */}
							<ReactSelect
								options={cityNameOption}
								onInputChange={(value) => setSearchTerm(value)} // User input pe search ho
								// onChange={handleCitySelect} // Select hone ke baad clear ho jaye
								onChange={(option) => handleFieldChange(setCitySearch, option ? option.value : "", "citySearch")}

								placeholder="Search & select city"
								classNamePrefix="react-select"
								className="form-control Dark-Input-from-group"
								styles={customStyles}
								isClearable
							/>
						</div>
						{/* {display && !citySearch ? (
              <span className="error_msg_lbl">Search & Select City </span>
            ) : null} */}
					</Col>

					<Col md={12} className="mb-2">
						<Form.Group controlId="description">
							<Form.Label className="class-type mt-2">Description</Form.Label>
							<Form.Control
								as="textarea"
								rows={3}
								value={description}
								// onChange={(e) => setDescription(e.target.value)}
								onChange={(e) => handleFieldChange(setDescription, e.target.value)} // Track changes
								placeholder="Enter description"
								className="custom-style Dark-Input-from-group"
							/>
							{/* {display && !description ? (
                <span className="error_msg_lbl">Enter Description</span>
              ) : null} */}
						</Form.Group>
					</Col>

					{/* Description */}
				</Row>

				{/* Submit Button */}
				<div className="d-flex justify-content-end mt-4">
					{/* <Button variant="secondary" onClick={handleClose} className="me-3">
                        Close
                    </Button> */}
					<div className="add-class-submit-button mt-4 d-flex justify-content-center">
						<div className="khojPrimaryBtn ms-3"
							onClick={handleSubmit}
							style={{ cursor: formChanged ? "pointer" : "default" }}
						>
							<a href="#/"
								// onClick={handleSubmit}
								className={`btn  ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
								// onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
								disabled={!formChanged || isSubmitting}
								style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
							>
								Submit
							</a>
						</div>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default AddExperience;
